module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "playback-time-picker-comp"
  }, [_c('div', {
    staticClass: "background",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "header"
  }, _vm._l((_vm.tabs), function(value, index) {
    return _c('div', {
      key: index,
      staticClass: "tab-btn",
      class: {
        selected: _vm.selectedTabIndex === index
      },
      on: {
        "click": function($event) {
          _vm.selectTab(index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "camera-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabs[_vm.selectedTabIndex] === 'time-lapse'),
      expression: "tabs[selectedTabIndex] === 'time-lapse'"
    }],
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.thumbnailVideoUrls[_vm.selectedDateIndex]),
      expression: "!thumbnailVideoUrls[selectedDateIndex]"
    }],
    staticClass: "no-recording-text"
  }, [_vm._v("No recording")]), _vm._v(" "), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.thumbnailVideoUrls[_vm.selectedDateIndex]),
      expression: "thumbnailVideoUrls[selectedDateIndex]"
    }],
    ref: "thumbnailVideo",
    attrs: {
      "webkit-playsinline": "",
      "playsinline": ""
    }
  }), _vm._v(" "), (_vm.thumbnailVideoUrls[_vm.selectedDateIndex]) ? _c('div', {
    staticClass: "control-container"
  }, [_c('div', {
    staticClass: "play-stop-btn",
    class: {
      loading: !_vm.isThumbnailVideoLoaded
    },
    on: {
      "click": function($event) {
        _vm.onClickActionBtnForThumbnailVideo()
      }
    }
  }, [(!_vm.isThumbnailVideoLoaded) ? _c('div', [_vm._v("Loading...")]) : (!_vm.isThumbnailVideoPaused) ? _c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]) : _c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 5v14l11-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "playback-rate-btn",
    on: {
      "click": function($event) {
        _vm.onClickThumbnailVideoPlaybackRate()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.thumbnailVideoPlaybackRates[_vm.thumbnailVideoDefaultPlaybackRateIndex] + 'x') + " \n              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabs[_vm.selectedTabIndex] === 'video'),
      expression: "tabs[selectedTabIndex] === 'video'"
    }],
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.recordingVideoUrls[_vm.selectedDateIndex]),
      expression: "!recordingVideoUrls[selectedDateIndex]"
    }],
    staticClass: "no-recording-text"
  }, [_vm._v("No recording")]), _vm._v(" "), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recordingVideoUrls[_vm.selectedDateIndex]),
      expression: "recordingVideoUrls[selectedDateIndex]"
    }],
    ref: "recordingVideo",
    attrs: {
      "webkit-playsinline": "",
      "playsinline": ""
    }
  }), _vm._v(" "), (_vm.recordingVideoUrls[_vm.selectedDateIndex]) ? _c('div', {
    staticClass: "control-container"
  }, [_c('div', {
    staticClass: "play-stop-btn",
    class: {
      loading: !_vm.isRecordingVideoLoaded
    },
    on: {
      "click": function($event) {
        _vm.onClickActionBtnForRecordingVideo()
      }
    }
  }, [(!_vm.isRecordingVideoLoaded) ? _c('div', [_vm._v("Loading...")]) : (!_vm.isRecordingVideoPaused) ? _c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]) : _c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 5v14l11-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "playback-rate-btn",
    on: {
      "click": function($event) {
        _vm.onClickRecordingVideoPlaybackRate()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.recordingVideoPlaybackRates[_vm.recordingVideoDefaultPlaybackRateIndex] + 'x') + " \n              ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-container"
  }, [_c('div', {
    staticClass: "dates-container"
  }, [_vm._v("\n               \n            "), _c('h-scroll-comp', {
    attrs: {
      "itemWidth": 100,
      "selectedItem": _vm.selectedDateIndex,
      "totalItems": _vm.dates.length
    }
  }, _vm._l((_vm.dates), function(value, index) {
    return _c('div', {
      key: value,
      staticClass: "date",
      class: {
        'selected': index === _vm.selectedDateIndex,
          'has-recording': _vm.thumbnailVideoUrls[index]
      },
      on: {
        "click": function($event) {
          _vm.onClickDate(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(value) + "\n              ")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dates-container"
  }, [_vm._v("\n               \n            "), _c('h-scroll-comp', {
    attrs: {
      "itemWidth": 100,
      "selectedItem": _vm.selectedHourIndex,
      "totalItems": _vm.hours.length
    }
  }, _vm._l((_vm.hours), function(value, index) {
    return _c('div', {
      key: value,
      staticClass: "date",
      class: {
        selected: index === _vm.selectedHourIndex
      },
      on: {
        "click": function($event) {
          _vm.onClickHour(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(value + _vm.getAmPm(index)) + "\n              ")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dates-container"
  }, [_vm._v("\n               \n            "), _c('h-scroll-comp', {
    attrs: {
      "itemWidth": 100,
      "selectedItem": _vm.selectedMinuteIndex,
      "totalItems": _vm.minutes.length
    }
  }, _vm._l((_vm.minutes), function(value, index) {
    return _c('div', {
      key: value,
      staticClass: "date",
      class: {
        selected: index === _vm.selectedMinuteIndex
      },
      on: {
        "click": function($event) {
          _vm.onClickMinute(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(value) + "\n              ")])
  }))], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "footer",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("\n        Close\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-051cab5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlaybackTimePickerComp.vue
// module id = 269
// module chunks = 1